import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { PageShell } from '../../shared/components/page-shell/page-shell';
import { ClinicProcedures } from './components/clinic-procedures/clinic-procedures';
import { InsuranceProcedures } from './components/insurance-procedures/insurance-procedures';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AppTabs } from '../../shared/components/app-tabs/app-tabs';

@Component({
    selector: 'app-procedures',
    standalone: true,
    imports: [CommonModule, PageShell, ClinicProcedures, InsuranceProcedures, TranslateModule, AppTabs],
    templateUrl: './procedures.html',
    styleUrl: './procedures.css',
})
export class Procedures implements OnInit {
    /** The Procedure Types tab was removed from the UI. Its component still
     *  exists under components/procedure-types-tab/ if it is ever wanted back;
     *  nothing else in the app links to it. */
    activeTab: 'clinic' | 'insurance' = 'clinic';
    tabs: any[] = [];
    /** Set from ?editEntityId=<id> (see insurance-billing-modal's "Edit insurance
     *  details" link, which opens this page in a new tab) so the Insurance tab
     *  can auto-open that entity's edit modal. */
    editEntityId: number | null = null;

    constructor(private translate: TranslateService, private route: ActivatedRoute) {}

    ngOnInit() {
        this.tabs = [
            { label: 'procedures_tab_clinic', value: 'clinic' },
            { label: 'procedures_tab_insurance', value: 'insurance' }
        ];

        const params = this.route.snapshot.queryParamMap;
        if (params.get('tab') === 'insurance') {
            this.activeTab = 'insurance';
        }
        const editEntityId = Number(params.get('editEntityId'));
        this.editEntityId = editEntityId > 0 ? editEntityId : null;
    }

    setActiveTab(tab: string) {
        this.activeTab = tab as 'clinic' | 'insurance';
    }
}
